// extracted by mini-css-extract-plugin
export default {"container":"need-it-now__container___1aFKD","phone":"need-it-now__phone___2cGUL","message":"need-it-now__message___1Byaf"};